import React from "react";
import { Button, DropdownButton, Dropdown, Form, Modal } from 'react-bootstrap';
import Locale from "../../../locale/Locale";

export default class StatusHistory extends React.Component {

    state = {
        historySearch: ""
    };

    render() {
        return (
            <div className="StatusHistory">
                <div className="row">
                    <div key="timeRangeSelector" className="col-md-2 pull-left">
                        <Form.Select size="sm" custom 
                            defaultValue={ this.props.detailScreen.state.historyHours } 
                            onChange={(e) => this.props.detailScreen.setState({ historyHours: e.target.value }, () => this.props.detailScreen.updateHistory()) }
                        >
                            <option value="3">last 3 hours</option>
                            <option value="6">last 6 hours</option>
                            <option value="12">last 12 hours</option>
                            <option value="24">last 24 hours</option>
                            <option value="72">last 72 hours</option>
                            <option value="168">last 168 hours</option>
                            <option value="336">Two weeks</option>
                            <option value="672">Four weeks</option>
                            <option value="1344">Eight weeks</option>
                        </Form.Select>
                    </div>
                    <div key="searchPhraseHolder" className="col-md-3 pull-left">
                        <Form.Control 
                            type="text"
                            //value={ this.state.historySearch }
                            onChange={ (event) => {
                                if (this.stateHistorySearchTimeout)
                                    clearTimeout(this.stateHistorySearchTimeout);
                                let phrase = event.target.value;
                                this.stateHistorySearchTimeout = setTimeout(() => {
                                    this.setState({ historySearch: phrase });
                                }, 200);
                            }}
                        />
                    </div>
                    <div key="filterHolder" className="col-md-4 pull-left">
                        <DropdownButton id="dropdown-basic-button" title={ "Mode: " + this.props.detailScreen.state.historyMode } style={{ display: 'inline-block' }}>
                            <Dropdown.Item onClick={ () => { this.setState({ historyMode: 'all' }, () => this.props.detailScreen.updateHistory() ) }}>All</Dropdown.Item>
                            <Dropdown.Item onClick={ () => { this.setState({ historyMode: 'controls' }, () => this.props.detailScreen.updateHistory() ) }}>Controls</Dropdown.Item>
                            <Dropdown.Item onClick={ () => { this.setState({ historyMode: 'devices' }, () => this.props.detailScreen.updateHistory() ) }}>Devices</Dropdown.Item>
                        </DropdownButton>
                        <DropdownButton id="dropdown-basic-button" title={ "Source: " + this.props.detailScreen.state.historySource } style={{ display: 'inline-block' }}>
                            <Dropdown.Item onClick={ () => { this.setState({ historySource: 'all' }, () => this.props.detailScreen.updateHistory() ) }}>All</Dropdown.Item>
                            <Dropdown.Item onClick={ () => { this.setState({ historySource: 'schedule' }, () => this.props.detailScreen.updateHistory() ) }}>Schedule</Dropdown.Item>
                            <Dropdown.Item onClick={ () => { this.setState({ historySource: 'freeze_protect' }, () => this.props.detailScreen.updateHistory() ) }}>Freeze Protect</Dropdown.Item>
                            <Dropdown.Item onClick={ () => { this.setState({ historySource: 'monitor' }, () => this.props.detailScreen.updateHistory() ) }}>Monitor</Dropdown.Item>
                            <Dropdown.Item onClick={ () => { this.setState({ historySource: 'local_ui' }, () => this.props.detailScreen.updateHistory() ) }}>Local Ui</Dropdown.Item>
                            <Dropdown.Item onClick={ () => { this.setState({ historySource: 'readyby_schedule' }, () => this.props.detailScreen.updateHistory() ) }}>ReadyBy Schedule</Dropdown.Item>
                        </DropdownButton>
                    </div>
                    <div key="refreshHolder" className="col-md-2 pull-right">
                        <Button onClick={ () => this.props.detailScreen.updateHistory() }>Refresh</Button>
                    </div>
                    <div key="countHolder" className="col-md-2 pull-right">
                        { this.props.detailScreen.state.itemHistory.length } rows
                    </div>
                </div>
                <table key="resultTable" style={{ width: '100%' }}>
                    <thead>
                        <tr style={{ border: "1px solid black" }}>
                            <td style={{ width: 100 }}>Time</td>
                            <td>Control</td>
                            <td>Device</td>
                            <td>Param</td>
                            <td>Status</td>
                            <td>Source</td>
                        </tr>
                    </thead>
                    <tbody>
                    {
                        this.props.detailScreen.state.historyLoading ? "Loading" : this.props.detailScreen.state.itemHistory.map((row, key) => {
                            let sourceController = this.props.detailScreen.state.itemConfig.Controllers.find((controller) => controller.UUID === row.Source);
                            let controlObj = this.props.detailScreen.state.itemConfig.Controls.find((control) => control.UUID === row.Control);
                            let controlGroup = controlObj ? this.props.detailScreen.state.itemConfig.ControlGroups.find((cg) => cg.UUID === controlObj.ControlGroupUUID) : null;
                            let deviceObj = this.props.detailScreen.state.itemConfig.Devices.find((dev) => dev.UUID === row.Device) || 
                                            this.props.detailScreen.state.itemConfig.BodiesOfWater.find((dev) => dev.UUID === row.Device);
                            let stamp = new Date(row.time);
                            
                            if (this.state.historySearch.length > 0) {
                                let sf = this.state.historySearch.toLowerCase();
                                if (
                                    (!controlObj?.Name || controlObj?.Name?.toLowerCase().indexOf(sf) === -1) &&
                                    (!deviceObj?.Name || deviceObj?.Name?.toLowerCase().indexOf(sf) === -1) &&
                                    (!row?.Param || row.Param?.toLowerCase().indexOf(sf) === -1) &&
                                    (!row?.Status || row.Status?.toLowerCase().indexOf(sf) === -1) &&
                                    (!row?.SourceName || row.SourceName?.toLowerCase().indexOf(sf) === -1) &&
                                    (!row?.Source || row.Source?.toLowerCase().indexOf(sf) === -1)
                                ) {
                                    return null;
                                }
                            }
                            return (
                                <tr key={"row_" + key}>
                                    <td>
                                        { Locale.formatDateTime(stamp, true) }
                                    </td>
                                    <td>
                                        { controlGroup?.Name || "" }<br/>
                                        { controlObj ? (controlObj.Name || controlObj.Type) : (row.ControlName || row.Control || "-") }
                                    </td>
                                    <td>{ deviceObj ? (deviceObj.Name || deviceObj.DeviceType) : row.Device }</td>
                                    <td>{ row.Param }</td>
                                    <td>{ (row.PrevStatus?.length > 150 || row.Status?.length > 150 ) ?
                                            ( <Button
                                                style={{  }}
                                                onClick={ () => {
                                                    console.log(row);
                                                    this.props.detailScreen.extraElement = (
                                                        <Modal
                                                            show={ true } 
                                                            scrollable={ true }
                                                            backdrop="static"
                                                            onHide={ () => { this.clearExtraElement(); } }
                                                            dialogClassName="wideDialog"
                                                        >
                                                            <Modal.Header closeButton >
                                                                <Modal.Title>Change info</Modal.Title>
                                                            </Modal.Header>
                                                            <Modal.Body style={{  }} >
                                                                <div style={{ display: 'inline-block', width: '45%', verticalAlign: 'top' }}>
                                                                    <pre>
                                                                        { JSON.stringify(JSON.parse(row.PrevStatus), null, 2) }
                                                                    </pre>
                                                                </div>
                                                                <div style={{ display: 'inline-block', width: '45%', verticalAlign: 'top' }}>
                                                                    <pre>
                                                                    { JSON.stringify(JSON.parse(row.Status), null, 2) }
                                                                    </pre>
                                                                </div>
                                                            </Modal.Body>
                                                            <Modal.Footer>
                                                                <Button variant="secondary" onClick={ () => { this.props.detailScreen.clearExtraElement(); }}>Close</Button>
                                                            </Modal.Footer>
                                                        </Modal>
                                                    );
                                                    this.props.detailScreen.setState({});
                                                } }
                                                >Details</Button>
                                            ) :
                                            row.PrevStatus + " -> " + row.Status
                                    }</td>
                                    <td>{ sourceController ? "Controller" : (row.SourceName || row.Source) }</td>
                                </tr>
                            )
                        })
                    }
                    </tbody>
                </table>
            </div>
        );
    }
}